import Vue from 'vue'
import Router from 'vue-router'
import routes from './route'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: window.__webpack_base_url__,
  routes
})

router.beforeEach((to, from, next) => {
  if (window.__xm_wx.isMiniProgram) {
    // 小程序内部只允许访问/store，/order/detail两个路由
    const isNotAccessRoute = !/(store|order\/detail)/.test(to.path)
    if (isNotAccessRoute) {
      // 小程序内部提示页
      window.wx.miniProgram.reLaunch({
        url: '/pages/mall/pages/error/index'
      })
      return
    }
  } 
  
  next()
})

 export default router
